import { IRecipient } from './recipient';

export interface IRecipientResponse {
    data: {
        success: boolean;
        results: IRecipient;
        message: string;
    }
}
